/**
 * Local constants for the Flow Planning Dashboard
 */

export enum TimePeriodInMinutes {
    FIFTEEN_MINUTES = '15',
    THIRTY_MINUTES = '30',
    FORTY_FIVE_MINUTES = '45',
    ONE_HOUR = '60',
}

export enum MonitoringEntityType {
    PROCESS_PATH = 'PROCESS_PATH',
}

export enum MetricName {
    UPH = 'UPH',
    VOLUME_PROCESSED = 'VOLUME_PROCESSED',
    HEADCOUNT = 'HEADCOUNT',
    HOURS = 'HOURS',
    /** Inflow into a node. Actual-only: no expected counterpart, so it rides on
     *  ProcessPathCard.actualsMetricsList rather than metricsComparisonList. */
    RECEIVED = 'RECEIVED',
    /** Units held in a path's buffer: actual = units, expected = capacity, variance = capacity used (%). */
    BUFFER = 'BUFFER',
    /** Inflow-vs-outflow imbalance: actual = units received in, expected = units processed out. */
    FLOW = 'FLOW',
    /** Average dwell of a buffer's units, in hours. Actual-only. Buffers page only. */
    AVG_DWELL_HOURS = 'AVG_DWELL_HOURS',
    /** Buffered units at risk of being lost. Actual-only. Buffers page only. */
    POTENTIAL_LOST_UNITS = 'POTENTIAL_LOST_UNITS',
}

export enum ComparisonStatus {
    AHEAD = 'AHEAD',
    ON_TRACK = 'ON_TRACK',
    AT_RISK = 'AT_RISK',
    CRITICAL = 'CRITICAL',
}

export enum BaselineReferenceType {
    LATEST_SHIFT_PLAN = 'LATEST_SHIFT_PLAN',
}

export enum VolumeTargetType {
    ALPS_TARGET = 'ALPS_TARGET',
    PRIMARY_GRADING_TARGET = 'PRIMARY_GRADING_TARGET',
    OVERRIDDEN_PRIMARY_GRADING_TARGET = 'OVERRIDDEN_PRIMARY_GRADING_TARGET',
}

/** Authoritative process-path classification. DIRECT shows Volume + Rate + HC; INDIRECT shows Rate + HC only. */
export enum ProcessPathType {
    DIRECT = 'DIRECT',
    INDIRECT = 'INDIRECT',
}

/** KPI represented by a pre-computed ShiftKpiComparison card. */
export enum ShiftKpiType {
    VOLUME_COMPLETED = 'VOLUME_COMPLETED',
    TPH = 'TPH',
    SUPPORT_RATE = 'SUPPORT_RATE',
    HC_STAFFED = 'HC_STAFFED',
}
